<template>
  <q-dialog
    :value="isOpen"
    @hide="$emit('close')"
  >
    <Card class="add-modal-card">
      <div class="title">
        Добавить магазин по номеру
      </div>

      <div class="form-group">
        <q-input
          dense
          outlined
        />
      </div>

      <div class="row reverse">
        <q-btn
          type="submit"
          size="16px"
          label="Добавить"
          unelevated
          color="primary"
        />
      </div>
    </Card>
  </q-dialog>
</template>

<script>
/**
 * Компонент отображает модальное окно добавления магазина
 * @module PageShop/Component/AddStoreModal
 * @requires Shared/Card
 */
import Card from 'Shared/Card'

export default {
  name: 'AddStoreModal',
  components: {
    Card
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.add-modal-card {
  min-width: 500px;

  .title {
    margin-bottom: 25px;

    font-size: 18px;
    font-weight: 600;
  }
}
</style>
